export const BlogDetails = () => {
  return `query BlogDetails($filters: BlogFiltersInput, $status: PublicationStatus, $locale: I18NLocaleCode) {
    blogs(filters: $filters, status: $status, locale: $locale) {
      publishedAt
      documentId
      locale
      media {
        url
        name
        caption
        alternativeText
      }
      short_description
      slug
      title
      author {
        avatar {
          alternativeText
          caption
          name
          url
        }
        name
      }
        category {
        name
        slug
      }
      seo {
        canonicalURL
        keywords
        metaDescription
        metaImage {
          caption
          createdAt
          alternativeText
          url
        }
        metaTitle
        metaViewport
        metaRobots
        structuredData
        openGraph {
          id
          ogTitle
          ogDescription
          ogImage {
            caption
            createdAt
            url
            name
          }
          ogUrl
          ogType
        }
          
        id
      }
      mobile_media {
        alternativeText
        caption
        url
      }
      content
    }
  }`;
};
